import { HoldResponseDto, HoldsApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetHoldsQuery implements IQueryMessage {
  static type = 'GetHoldsQuery'
  type = GetHoldsQuery.type

  constructor(
    public containerJourneyIds?: number[],
    public includeAll?: boolean,
  ) {}
  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(HoldsApi)

export const getHoldsQueryHandler: IQueryHandler<
  GetHoldsQuery,
  IEvent<HoldResponseDto[]>
> = async query => {
  const { data } = await httpClient.getAll(query.containerJourneyIds, query.includeAll ?? false)

  return new Event(GetHoldsQuery.type, data)
}
